import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableNotFound = Loadable({
  loader: function loader() {
    return import('../NotFound.jsx');
  },
  loading: ComponentLoading
});
export default LoadableNotFound;